/** Shared display type for a test row inside a panel expansion. */
export interface CatalogTestDisplay {
    id: number;
    name: string;
    code: string;
    addonPrice: number;
    isCalculated: boolean;
    inAssayCatalog: boolean;
    isMissingPrerequisite: boolean;
}

/** Shared display type for a panel card. */
export interface CatalogPanelDisplay {
    id: number;
    name: string;
    code: string;
    testCount: number;
    tests: CatalogTestDisplay[];
    totalAddonPrice: number;
    isBundledPanel?: boolean;
}

/** Format a numeric price as "$XX.XX". */
export function formatCatalogPrice(price: number): string {
    return `$${price.toFixed(2)}`;
}
